import {
  login,
  logout,
  getInfo,
  getVerification,
  postRegist,
  postSendsms,
  retrievePassword,
  modifyPassword,
  getIsVerification
} from "@/api/login";
import { getToken, setToken, removeToken } from "@/utils/auth";

const user = {
  state: {
    token: getToken(),
    name: "",
    avatar: "",
    roles: [],
    nameid: "",
    admin: false
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_NAME: (state, name) => {
      state.name = name;
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar;
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles;
    },
    SET_NAMEID: (state, nameid) => {
      state.nameid = nameid;
    },
    SET_ADMIN: (state, admin) => {
      state.admin = admin;
    }
  },

  actions: {
    // 登录
    Login({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        login(resdata)
          .then(response => {
            if (response.data.redirect_url != "") {
              var redirectURL = decodeURIComponent(response.data.redirect_url);
              window.location.href = redirectURL;
              return;
            }
            const tokenStr = response.data.token;
            setToken(tokenStr);
            commit("SET_TOKEN", tokenStr);
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    SetToken({ commit }, resdata) {
      setToken(resdata);
      commit("SET_TOKEN", resdata);
    },
    // 验证码
    Verification() {
      return new Promise((resolve, reject) => {
        getVerification()
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // 显示验证码
    IsVerification() {
      return new Promise((resolve, reject) => {
        getIsVerification()
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // 注册
    Regist({ commit }, userdata) {
      return new Promise((resolve, reject) => {
        postRegist(userdata)
          .then(response => {
            if (response.data.redirect_url != "") {
              var redirectURL = decodeURIComponent(response.data.redirect_url);
              window.location.href = redirectURL;
              return;
            }
            const tokenStr = response.data.token;
            setToken(tokenStr);
            commit("SET_TOKEN", tokenStr);
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // 发送短信验证码
    Sendsms({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        postSendsms(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // 找回密码
    RetrievePassword({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        retrievePassword(resdata)
          .then(response => {
            const tokenStr = response.data;
            commit("SET_TOKEN", tokenStr);
            setToken(tokenStr);
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // 修改密码
    ModifyPassword({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        modifyPassword(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo()
          .then(response => {
            const data = response.data;
            commit("SET_AVATAR", data.icon);
            commit("SET_NAME", response.data.username);
            commit("SET_NAMEID", response.data.user_id);
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.nameid)
          .then(() => {
            localStorage.clear();
            commit("SET_TOKEN", "");
            commit("SET_ROLES", []);
            commit("reset");
            removeToken();
            resolve();
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        localStorage.clear();
        commit("SET_TOKEN", "");
        commit("SET_ROLES", []);
        commit("reset");
        removeToken();
        resolve();
      });
    }
  }
};

export default user;



// WEBPACK FOOTER //
// ./src/store/modules/user.js